import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const Login = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const navigate = useNavigate();

    const handleSubmit = (e) => {
        e.preventDefault();
        if (email === 'admin@pricol.com' && password === 'Pricol@4321') {
            localStorage.setItem('isLoggedIn', 'true');
            navigate('/dashboard');
        } else {
            setError('Invalid username or password');
        }
    };

    return (
        <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f5f7fa' }}>
            <form onSubmit={handleSubmit} style={{ background: '#fff', padding: 32, borderRadius: 8, boxShadow: '0 2px 12px rgba(0,0,0,0.08)', minWidth: 320, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <img src="/logo.png" alt="Pricol Logo" style={{ width: 120, marginBottom: 24 }} />
                <h2 style={{ marginBottom: 24 }}>Login</h2>
                {error && <div style={{ color: '#c62828', background: '#ffebee', padding: 8, borderRadius: 4, marginBottom: 16, width: '100%', textAlign: 'center' }}>{error}</div>}
                <div style={{ width: '100%', marginBottom: 16 }}>
                    <label htmlFor="email" style={{ display: 'block', marginBottom: 6, fontWeight: 500 }}>Email</label>
                    <input
                        type="email"
                        id="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                        style={{ width: '100%', padding: 10, borderRadius: 4, border: '1px solid #ddd', fontSize: 16 }}
                    />
                </div>
                <div style={{ width: '100%', marginBottom: 24 }}>
                    <label htmlFor="password" style={{ display: 'block', marginBottom: 6, fontWeight: 500 }}>Password</label>
                    <input
                        type="password"
                        id="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                        style={{ width: '100%', padding: 10, borderRadius: 4, border: '1px solid #ddd', fontSize: 16 }}
                    />
                </div>
                <button type="submit" style={{ width: '100%', padding: 12, background: '#1976d2', color: '#fff', border: 'none', borderRadius: 4, fontSize: 18, fontWeight: 600, cursor: 'pointer' }}>Login</button>
            </form>
        </div>
    );
};

export default Login; 